// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a4c6b8b5","453":"9c5ca3de","455":"972c2542","977":"3f62c7ff"}[chunkId] + ".chunk.js";
};